exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nowrap[data-v-3bd3d7fa]{white-space:nowrap}@media (max-width: 992px){.delivery-select[data-v-3bd3d7fa]{margin-top:5px}}\n", ""]);

// exports
